<template>
  <div>
    <div class="search">
      <el-input
        class="searchInput"
        placeholder="请输入工作单位"
        v-model="searchKeyword"
        @keydown="handleSearch"></el-input>
      <el-button type="primary" @click="handleSearch">查询</el-button>
    </div>
    <div class="nodes">
      <div v-for="(item, index) in currentList" :key="index">
        <span> {{ item.orgName }}</span>
        <span
          v-if="currentList.length - 1 != index"
          style="margin: 0 5px; color: #000">
          >
        </span>
      </div>
      <div
        style="margin-left: 10px; cursor: pointer"
        @click="handleUnCurrentList">
        <span style="color: #000">[</span> 返回
        <span style="color: #000">]</span>
      </div>
    </div>
    <div class="orgList">
      <div class="orgItme" v-for="(item, index) in orgTreeList" :key="index">
        <div @click="handleOrgList(item)">
          {{ item.orgName }}
        </div>
      </div>
    </div>

    <div>
      <div>
        <span @click="handleClear" style="cursor: pointer; color: #1d8ade">
          <span style="color: #000">[</span> 清空
          <span style="color: #000">]</span>
        </span>
        当前选择的是:
        {{ currentList[currentList.length - 1].orgName }}
      </div>
    </div>
  </div>
</template>

<script>
import { getOrgTree, searchOrg } from "@/api/user";
export default {
  data() {
    return {
      formData: { schoolId: "中共西藏自治区委员会办公厅" },
      orgTreeList: [],
      rules: {},
      currentList: [
        { orgName: "单位", orgId: undefined },
        { orgName: "西藏自治区", orgId: undefined },
      ],
      searchKeyword: undefined,
      isSearchKeywod: false,
    };
  },
  created() {
    this.getOrgTree();
  },
  methods: {
    splitToArray(str) {
      let arr = [];
      for (let i = 3; i <= str.length; i += 3) {
        arr.push(str.slice(0, i));
      }
      return arr;
    },

    async buildTreeByParentCodes(parentCodes) {
      // 当前 parentCode
      if (!parentCodes.length) return [];
      const currentCode = parentCodes[0];
      // 获取当前节点的 children
      const res = await getOrgTree({ parentCode: currentCode });
      const children = res.result || [];
      children.forEach((item, index) => {
        if (item.orgId == parentCodes[1]) {
          console.log(item.orgId);
          this.currentList.push(item);
        }
      });

      // 如果还有下一级 parentCode
      if (parentCodes.length > 1 && children.length > 0) {
        const nextCode = parentCodes[1];
        // 找到 code 等于下一个 parentCode 的节点
        const nextNode = children.find((child) => child.orgId == nextCode);

        if (nextNode) {
          // 递归组装下一级
          let arr = parentCodes.slice(1);
          nextNode.children = await this.buildTreeByParentCodes(arr);
        }
      }

      return children;
    },
    handleOrgList(item) {
      if (this.isSearchKeywod) {
        this.currentList = [
          { orgName: "单位", orgId: undefined },
          { orgName: "西藏自治区", orgId: undefined },
        ];
        const arr = this.splitToArray(item.orgId);
        this.buildTreeByParentCodes(arr);
      } else {
        this.currentList.push(item);
        this.getOrgTree(item.orgId);
      }
    },
    async handleSearch() {
      if (this.searchKeyword) {
        this.isSearchKeywod = true;
        const res = await searchOrg({ searchKeyword: this.searchKeyword });
        this.orgTreeList = res.result;
      } else {
        this.$message.warning("请输入工作单位在点击查询");
      }
    },

    handleClear() {
      if (this.currentList.length == 2) {
        return this.$message.warning("当前已是根节点无需清空");
      }
      this.currentList = [
        { orgName: "单位", orgId: undefined },
        { orgName: "西藏自治区", orgId: undefined },
      ];
      this.searchKeyword = undefined;
      this.getOrgTree();
    },
    handleUnCurrentList() {
      if (this.currentList[this.currentList.length - 1].orgId) {
        this.currentList.pop();
        this.getOrgTree(this.currentList[this.currentList.length - 1].orgId);
      } else {
        this.$message.warning("当前已是根节点无法返回");
      }
    },
    async getOrgTree(parentCode) {
      this.orgTreeList = [];
      this.isSearchKeywod = false;
      const res = await getOrgTree({
        parentCode: parentCode ? parentCode : "001",
      });
      const array = res.result;
      this.orgTreeList = array;
    },
    handleSubmit() {
      console.log(this.formData);
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  display: flex;
  align-items: center;
  .searchInput {
    width: 200px;
    margin-right: 20px;
  }
}
.nodes {
  display: flex;
  color: #1d8ade;
}
.orgList {
  display: flex;
  // 自动换行
  flex-wrap: wrap;
  padding: 10px;
  .orgItme {
    margin: 5px 20px;
    width: 200px;
    color: red;
    cursor: pointer;
  }
}
</style>
